import React from 'react';
import './card.styles.css'

export const Card = (props) => (
    <div className='card-container'>
        <img src={`https://robohash.org/${props.kitten.id}?set=set4&size=200x200`} alt="kitten"/>
        <h2> { props.kitten.name } </h2>
        <p> { props.kitten.email } </p>
        <p> { props.kitten.website } </p>
    </div>
)